import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const ptStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'Convidar no WhatsApp',
  NLSWhatsappInviteDialogTitle: 'Convidar no WhatsApp',
  NLSWhatsappInviteDialogCopy: 'Copiar link',
  NLSWhatsappInviteDialogShare: 'Compartilhar',
  NLSWhatsappSendFromMineAction: 'Enviar do meu WhatsApp',
  NLSWhatsappSendFromMineText: 'Olá {name}, aqui é {sender} de {workspace}.',
  NLSWhatsappSlipQrCaption: 'Converse conosco no WhatsApp',
  NLSWhatsappChipLinked: 'WhatsApp vinculado',
  NLSWhatsappChipNotYet: 'WhatsApp: ainda não',
  NLSWhatsappChipStopped: 'WhatsApp: parado',
  NLSEduAnnouncementSendWhatsappAction: 'Enviar pelo WhatsApp',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'Enviar pelo WhatsApp',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'Enviar',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: 'Envia para {n} responsáveis',
  NLSEduAnnouncementSendWhatsappSummaryCredits: 'Envia para {n} responsáveis · cerca de {credits} créditos',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'Grátis no limite do seu plano',
  NLSEduAnnouncementSendWhatsappReasonOff: 'O WhatsApp está desativado para este espaço.',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'O envio de avisos do administrador está desativado nas configurações.',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'Nenhum responsável com consentimento telefônico verificado foi encontrado.',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'O envio por WhatsApp está pausado devido a créditos insuficientes.',
  NLSEduAnnouncementSentWhatsappCount: 'Enviado pelo WhatsApp para {count}',
  NLSCommonRailPageShellSidecarSheet: "Painel de detalhes",
  NLSCommonActionBackToWorkspace: 'Voltar ao workspace',
  NLSCommonActionBack: 'Voltar',
  NLSCommonActionCancel: 'Cancelar',
  NLSCommonActionContinue: 'Continuar',
  NLSCommonActionSignOut: 'Sair',
  NLSCommonActionRetryLoadingWorkspaces: 'Tentar workspaces',
  NLSCommonActionRetrying: 'Tentando...',
  NLSCommonActionDownload: 'Baixar',
  NLSCommonActionOpen: 'Abrir',
  NLSCommonActionReloadThisTab: 'Recarregar aba',
  NLSCommonActionMarkUpInDesign: 'Marcar no Design',
  NLSCommonAriaAccessDenied: 'Acesso negado',
  NLSCommonAriaClosePreview: 'Fechar previa',
  NLSCommonAriaConnectionStatus: 'Status da conexao',
  NLSCommonAriaPreviewAttachment: 'Previa de {label}',
  NLSCommonEmptyNoActions: 'Sem acoes',
  NLSCommonEmptyNoOptions: 'Sem opcoes',
  NLSCommonErrorGeneric: 'Algo deu errado.',
  NLSCommonInputSearchPlaceholder: 'Buscar',
  NLSCommonInputSearchEllipsisPlaceholder: 'Buscar…',
  NLSCommonInputSearchOptionsPlaceholder: 'Buscar opcoes',
  NLSCommonInputSelectPlaceholder: 'Selecionar',
  NLSCommonInputSelectEllipsisPlaceholder: 'Selecionar…',
  NLSCommonStatusApi: 'API',
  NLSCommonStatusLoading: 'Carregando',
  NLSCommonLanguageAriaLabel: 'Idioma do app',
  NLSCommonLanguageLabel: 'Idioma',
  NLSCommonAccessDeniedDefaultMessage: 'Seu perfil de conta nao pode acessar esta area.',
  NLSCommonAccessDeniedTitle: 'Acesso negado',
  NLSCommonConnectivityDescription: 'A ultima solicitacao falhou porque este dispositivo parece offline. Reconecte e tente a acao novamente. Seu workspace continua aberto por tras.',
  NLSCommonConnectivityEyebrow: 'Conexao interrompida',
  NLSCommonConnectivityRequestPaused: 'Solicitacao pausada',
  NLSCommonConnectivityTitle: 'Timelining nao alcancou a rede.',
  NLSCommonPreviewAttachmentUnavailable: 'Anexo indisponivel.',
  NLSCommonPreviewFormatUnavailable: 'A previa nao esta disponivel para este formato aqui. Voce ainda pode abrir ou baixar o arquivo original.',
  NLSCommonPreviewKindAsset: 'Asset',
  NLSCommonPreviewKindAudio: 'Audio',
  NLSCommonPreviewKindDocument: 'Documento',
  NLSCommonPreviewKindFile: 'Arquivo',
  NLSCommonPreviewKindImage: 'Imagem',
  NLSCommonPreviewKindLink: 'Link',
  NLSCommonPreviewKindSpreadsheet: 'Planilha',
  NLSCommonPreviewKindTimelineItem: 'Item da linha',
  NLSCommonPreviewKindVideo: 'Video',
  NLSCommonPreviewPreparingText: 'Preparando previa...',
  NLSCommonPreviewTextBlocked: 'A previa de texto esta bloqueada para este arquivo. Abra ou baixe o original.',
  NLSCommonPreviewTextTruncated: 'Previa truncada',
  NLSCommonTabErrorBody: 'O resto do app esta bem. Use as abas inferiores para navegar ou tente recarregar esta aba.',
  NLSCommonTabErrorTitle: 'Esta aba falhou',
  NLSAuthEyebrowCloudWorkspace: 'Workspace na nuvem',
  NLSAuthEyebrowHelperAccess: 'Acesso helper',
  NLSAuthTitleCloudWorkspace: 'Mapeie suas metas. Ou as da sua equipe.',
  NLSAuthTitleHelperPhone: 'Entre com seu telefone.',
  NLSAuthActionCheckSession: 'Verificar sessao',
  NLSAuthActionContinueGoogle: 'Continuar com Google',
  NLSAuthActionOpeningGoogle: 'Abrindo Google...',
  NLSAuthActionSendOtp: 'Enviar OTP',
  NLSAuthActionSendingOtp: 'Enviando OTP...',
  NLSAuthActionVerifySignIn: 'Verificar e entrar',
  NLSAuthActionVerifying: 'Verificando...',
  NLSAuthActionUseDifferentNumber: 'Usar outro numero',
  NLSAuthFieldPhoneNumber: 'Telefone',
  NLSAuthFieldVerificationCode: 'Codigo',
  NLSOnboardingEyebrowNewSpace: 'Um novo espaco espera',
  NLSOnboardingTitleBegin: 'Por onde voce quer comecar?',
  NLSOnboardingPersonalTitle: 'Espaco pessoal',
  NLSOnboardingActionLaunchPersonal: 'Abrir espaco pessoal',
  NLSOnboardingTeamTitleCreate: 'Workspace de equipe',
  NLSOnboardingActionExploreTeam: 'Explorar equipe',
  NLSOnboardingTabInvites: 'Convites',
  NLSOnboardingTabDiscover: 'Descobrir',
  NLSOnboardingTabCreateNew: 'Criar',
  NLSShellRailSectionBoard: 'Board',
  NLSShellRailSectionControls: 'Controles',
  NLSShellRailDays: 'dias',
  NLSShellRailPersonalWallet: 'Carteira pessoal',
  NLSShellRailTileDashboard: 'Dashboard',
  NLSShellRailTileCalendar: 'Calendario',
  NLSShellRailTileMembers: 'Membros',
  NLSShellRailTileSettings: 'Ajustes',
  NLSShellRailTileNotifications: 'Notificacoes',
  NLSShellRailTileLogOut: 'Sair',
  NLSOpsRequestKindReliefNeeded: 'Substituição necessária',
  NLSOpsRequestKindIncident: 'Incidente',
  NLSOpsRequestKindClientComplaint: 'Reclamação do cliente',
  NLSOpsRequestKindSupplyRequest: 'Pedido de suprimentos',
  NLSOpsRequestKindPm: 'Manutenção preventiva',
  NLSOpsRequestKindCalibration: 'Calibração',
  NLSOpsReliefNeededTitle: 'Substituição necessária: {roleLabel} em {placeName} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'Postos de serviço por local e turno · uma ausência gera solicitação de substituição',
  NLSOpsSitesSelectSite: 'Selecionar local',
  NLSOpsSitesDay: 'Dia',
  NLSOpsSitesSelectShift: 'Selecionar turno',
  NLSOpsSitesPostsBoardTitle: 'Postos e substituições',
  NLSOpsSitesColPost: 'Posto',
  NLSOpsSitesColNeeds: 'Necessidade',
  NLSOpsSitesColOnDuty: 'De plantão',
  NLSOpsSitesColState: 'Estado',
  NLSOpsSitesStateCovered: 'Coberto',
  NLSOpsSitesStateShort: 'Deficitário',
  NLSOpsSitesStateReliefNeeded: 'Requer substituto',
  NLSOpsSitesStateReliefAssigned: 'Substituto atribuído',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'ausente',
  NLSOpsSitesReliefInbox: 'Caixa de substituições',
  NLSOpsSitesReliefFootnote: 'Uma ausência na lista gera RELIEF_NEEDED automaticamente e avisa sobre a cobertura (A6).',
  NLSOpsSitesFreeCandidates: 'Candidatos disponíveis:',
  NLSOpsSitesOffToday: 'de folga hoje',
  NLSOpsSitesAssignBtn: 'Atribuir',
  NLSOpsSitesAssignCandidateBtn: 'Atribuir {name}',
  NLSOpsSitesAssignDialogTitle: 'Atribuir substituto',
  NLSOpsSitesPrintPostSheet: 'Imprimir folha de postos',
  NLSOpsSitesNoPosts: 'Nenhum posto de serviço configurado para este local.',
  NLSOpsSitesNoReliefNeeded: 'Nenhuma substituição necessária.',
  NLSOpsSitesNoSites: 'Nenhum local de cliente encontrado.',
  NLSOpsSitesNoShifts: 'Nenhum turno disponível.',
  NLSOpsSitesPostSheetTitle: 'Folha de postos · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'Não é possível atribuir substituto: a solicitação não está mais aberta.',
  NLSOpsSitesErrorOnLeave: 'Não é possível atribuir substituto: a pessoa está de licença aprovada.',
  NLSOpsSitesErrorDoubleBooked: 'Não é possível atribuir substituto: a pessoa já está atribuída a este turno.',
  NLSOpsSitesErrorRoleCeiling: 'Não é possível atribuir substituto: o nível de função do membro impede a atribuição.',
  NLSOpsSitesErrorGeneric: 'Falha ao atribuir substituto.',
  NLSOpsSitesErrorNotFound: 'Registro ou solicitação não encontrado.',
  NLSOpsSitesErrorMissingAttributes: 'A solicitação não possui os atributos de substituto necessários.',
  NLSOpsSitesErrorInactivePerson: 'Não é possível atribuir substituto: a pessoa está inativa no espaço de trabalho.',
  NLSOpsRequestsUnassigned: 'Não atribuído',
  NLSOpsRequestsDetailUnassigned: 'Não atribuído',
  NLSOpsSitesIncidentsSubtitle: 'Incidentes (restritos) · reclamações de clientes · pedidos de suprimentos · auditorias do supervisor',
  NLSOpsSitesIncidentsTitle: 'Incidentes',
  NLSOpsSitesRestrictedTag: 'restrito',
  NLSOpsSitesAuditScoresTitle: 'Pontuações de auditoria',
  NLSOpsSitesSupervisorRegisterTag: 'registro do supervisor',
  NLSOpsSitesColSite: 'Local',
  NLSOpsSitesColLastAudit: 'Última auditoria',
  NLSOpsSitesColScore: 'Pontuação',
  NLSOpsSitesRecordAuditBtn: 'Registrar auditoria',
  NLSOpsSitesComplaintsSupplyTitle: 'Reclamações e pedidos de suprimentos',
  NLSOpsSitesNoIncidents: 'Nenhum incidente registrado.',
  NLSOpsSitesNoComplaintsSupply: 'Nenhuma reclamação ou pedido de suprimentos.',
  NLSOpsSitesNoAudits: 'Nenhuma auditoria registrada.',
  NLSOpsSitesNoAuditTemplate: 'Nenhum modelo de auditoria de local do supervisor configurado.',
  NLSOpsSitesOpenTemplatesBtn: 'Abrir modelos',
} satisfies NlsStringMap

export default ptStringsNls
